module.exports = __webpack_public_path__ + "img/rl-bottomBg.35e352c6.png";